// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__7kiZk","label":"styles_label___j9lq","icon":"styles_icon__5zEa9"};